import type { SVGProps } from 'react';

export function AIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 414 414" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M225.987 52.1954C229.249 42.5272 242.96 42.6276 246.08 52.3425L261.575 100.596C268.906 123.425 286.937 141.228 309.859 148.27L361.53 164.144C371.532 167.217 371.475 181.395 361.449 184.388L310.344 199.644C287.147 206.569 268.862 224.495 261.481 247.549L246.082 295.649C242.968 305.375 229.24 305.476 225.984 295.795L209.417 246.538C201.856 224.058 183.888 206.623 161.189 199.741L110.508 184.375C100.54 181.353 100.483 167.261 110.426 164.158L161.676 148.167C184.097 141.172 201.81 123.861 209.317 101.608L225.987 52.1954Z"
        fill="currentColor"
      />
      <path
        d="M109.805 239.737C111.498 234.716 118.611 234.768 120.229 239.814L128.268 264.875C132.072 276.732 141.426 285.979 153.318 289.637L180.124 297.881C185.313 299.477 185.284 306.841 180.083 308.395L153.569 316.319C141.535 319.916 132.049 329.226 128.22 341.2L120.231 366.182C118.615 371.234 111.493 371.286 109.804 366.258L101.209 340.675C97.2863 328.999 87.9645 319.944 76.1883 316.369L49.895 308.389C44.7235 306.819 44.694 299.5 49.8527 297.888L76.441 289.583C88.0728 285.95 97.2622 276.959 101.157 265.401L109.805 239.737Z"
        fill="currentColor"
      />
    </svg>
  );
}
